<template>
  <div v-if="showInventoryProgress" class="inventory-progress-bar">
    <div class="inventory-progress-bar__wrapper">
      <span
        class="inventory-progress-bar__label"
        v-text="
          $string('product.variant.inventory_alert', {
            replace: { percent: remainingPercent },
          })
        "
      />
      <div class="inventory-progress-bar__bar-container">
        <div
          class="inventory-progress-bar__bar-inner"
          :class="{
            'inventory-progress-bar__bar-inner--red': remainingPercent < 25,
            'inventory-progress-bar__bar-inner--yellow': remainingPercent < 50,
            'inventory-progress-bar__bar-inner--green': remainingPercent >= 50,
          }"
          :style="{ width: `${remainingPercent}%` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Stock progress bar (inventory-progress-bar)
 * -----------------------------------------------------------------------------
 * Show remaining stock progress bar compared to initial stock set in metafield.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
export default {
  name: 'InventoryProgressBar',

  props: {
    variant: {
      type: [Boolean, Object],
      default: () => ({}),
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    remainingPercent() {
      return Math.round(
        (this.variant.inventory / this.variant.initialInventory) * 100 || 0,
      );
    },

    showInventoryProgress() {
      return (
        this.variant.initialInventory &&
        this.variant.initialInventory > 0 &&
        this.variant.availableState === 'available'
      );
    },
  },
};
</script>

<style lang="scss">
@import './inventory-progress-bar';
</style>
